export enum TriggerStatusEnum {
    PUBLIC = 'public',
    ACTIVE = 'active',
    INACTIVE = 'inactive',
    DELETED = 'deleted'
}